import { connect } from "react-redux";
import PayslipTable from "../payroll-history/PayslipTable";
import { Actions as ACTIONS } from "../../store/actions/payslipActions";
import { useEffect } from "react";
import { format } from "date-fns";
import InvalidPermissions from "../company-pages/InvalidPermissions";
import { cloneDeep } from "lodash";

const EmployeePayslips = ({ getPayslips, payslips, columns, agreementId, userPermissions }) => {
	useEffect(() => {
		getPayslips(agreementId);
	}, [""]);

	if (userPermissions == "None") return <InvalidPermissions />;

	return (
		<PayslipTable
			payslips={payslips}
			columns={columns}
			itemsPerPage={12}
			location="employeePayslips"
		/>
	);
};

const mapStateToProps = (state) => {
	const employeeId = state.employee?.employeeDetails?.id;
	const payslips = cloneDeep(state.payslipHistory?.payslips?.filter((p) => p.agreementId === employeeId));

	const updatedPayslips = payslips
		?.map((payslip) => {
			let periodDescription, periodDate, periodComplete;

			if (payslip?.payPeriodId) {
				payslip.period = state.payPeriods?.periods?.find((p) => p.id === payslip.payPeriodId);
			}

			if (payslip?.period) {
				periodDescription =
					payslip.period.payPeriods === 12
						? format(new Date(payslip.period.periodStart), "MMM yyyy")
						: `Pay ${payslip.period.period} ${payslip.period.year}`;
				periodDate = format(new Date(payslip.period.year, payslip.period.period - 1), "yyyy-MM-dd");
				periodComplete = payslip.period.complete;
			} else {
				periodDescription = "Unknown Period";
				periodDate = "Unknown Date";
				periodComplete = "Unknown";
			}

			return {
				...payslip,
				periodDescription,
				periodDate,
				periodComplete,
			};
		})
		?.filter((p) => p.periodComplete && p.ready);

	const jurisdiction = state.company?.settings?.jurisdiction;

	const taxList = {
		UK: { PAYE: "PAYE", NIC: "NIC", StudentLoan: "Student Loans", Pension: "Pensions" },
		MT: { FSS: "Income Tax", SSC: "Social Security" },
	};

	const columns = [
		{ hidden: true },
		{ title: "Period", code: "periodDate", sort: true },
		{ title: "Gross", code: "gross", sort: true },
		...Object.values({ ...taxList[jurisdiction] }).map((tax) => ({
			title: tax,
			info: "Click on values to view Tax Calculations",
		})),
		{ title: "Net", code: "net", sort: true },
		{ title: "Portal Access" },
		{ hidden: true },
	];

	return {
		payslips: updatedPayslips,
		columns,
		agreementId: state.employee?.employeeDetails?.id,
		userPermissions: state?.permissions?.my?.permissions?.payroll,
	};
};

const mapDispatchToProps = (dispatch) => ({
	getPayslips: (agreementId) => dispatch(ACTIONS.getPayslipsByAgreement({ agreementId })),
});

export default connect(mapStateToProps, mapDispatchToProps)(EmployeePayslips);
